import React from 'react';
import { Container } from 'react-bootstrap';

export default function QuestionNotifyScreen(props) {
    return <Container className="d-flex flex-column justify-content-center text-center align-items-center h-100 w-100">
                <h1 className='display-1 my-4'><b>{props.t('Pay attention')}</b></h1>
                <h1 className='display-4 my-4'><b>{props.t('The number of questions in the pre-shift testing has changed')}!</b></h1>
                <h1 className='display-8 my-4'>{props.t('Number of questions')}<b className='text-danger'>{props.total}</b></h1>
                {props.counterEducaionQuestions?Object.keys(props.counterEducaionQuestions).map((key)=>{ 
                        let item  = props.counterEducaionQuestions[key];
                        return <span key={key} className='display-7 my-1 text-muted'>{props.t(item.title)}: {item.count}</span>
                }):[]}
                <h1 className='display-8 my-4'>{props.t('Testing will start')}: <b className='text-success'>{props.time}</b></h1>
           </Container>
};